/**
 * @ngdoc function
 * @name lmApp.controller:ProfileController
 * @description
 * # ProfileController
 * Controller of the lmApp
 */
lmApp
  .controller('ProfileController',
    ['$timeout', '$scope', '$rootScope', '$q', '$compile', '$templateCache', 'ModalWindowService', 'ProfileService', 'Platforms', 'ToastService', 'MetadataService', 'OperatorRsc', 'TimezoneService', 'ManagerResource', 'OperatorResource',
      function ($timeout, $scope, $rootScope, $q, $compile, $templateCache, ModalWindowService, ProfileService, Platforms, ToastService, MetadataService, OperatorRsc, TimezoneService, ManagerResource, OperatorResource) {

        var getPlatformIcon = MetadataService.GetPlatformIcon;
        var getPlatformName = MetadataService.GetPlatformName;
        var getPlatformApp = MetadataService.GetPlatformApp;
        var getAppUrl = function (platform) {
          var extid = platform.extid || platform.ext_id;

/*          if (platform.app_url === '' && extid === 'android') {
            return 'https://play.google.com/store/apps/details?id=com.sotalcloud.ng';
          }

          if (platform.app_url === '' && extid === 'ios') {
            return 'https://itunes.apple.com/us/app/sotalng/id1301990330';
          }*/

          return platform.app_url;
        };

        $scope.apps = {};
        $scope.info = {};

        $scope.profileData = {
          operator: {},
          operatorv2: {}
        };

        $scope.langs = [];
        $scope.newLangValidateErrors = {};
        $scope.newLang = {};
        var languages = angular.copy(MetadataService.languages.list);
        $scope.languages = [];
        var langCodeToTitle = {};
        for (var i=0; i < languages.length; i++) {
          var lang = languages[i];
          langCodeToTitle[lang.id] = lang.title;
        }

        $scope.manager = {};
        $scope.selectedTimezone = {};
        $scope.timezones = angular.copy(TimezoneService.Timezones);

        $scope.getSelfInfo = function (account, currentUser) {
          if (!account) return;

          $scope.profileData.loading = true;
          $rootScope.showLinearProgress('#profileLoader');

          ManagerResource.get().$promise
            .then(function (result) {
              $scope.manager = _.find(result, {username: account.email});
              var tz = $scope.manager.ui_timezone || 'UTC';
              $scope.selectedTimezone = _.find(TimezoneService.Timezones, {title: tz});
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
            });

          $scope.info.name = account.first_name + ' ' + account.last_name;

          if (!$scope.info.name || $scope.info.name === ' ') {
            $scope.info.name = 'N/A';
          }

          $scope.info.company = currentUser.company_name;
          if (!$scope.info.company) {
            $scope.info.company = 'N/A';
          }

          $scope.info.email = account.email;
          if (!$scope.info.email) {
            $scope.info.email = 'N/A';
          }

          $scope.profileData.loading = false;
          $rootScope.hideLinearProgress('#profileLoader');
        };

        if ($rootScope.globals.currentUser.isSuperuser) {
          $scope.getSelfInfo(_.get($rootScope.currentOperator, 'accounts.0.'), $rootScope.globals.currentUser);
        } else if ($rootScope.globals.currentUser.account) {
          $scope.getSelfInfo($rootScope.globals.currentUser.account, $rootScope.globals.currentUser);
        }

        $scope.saveData = function () {
          if ($scope.profileData.loading) return;
          $scope.profileData.loading = true;
          $rootScope.showLinearProgress('#profileLoader');

          var langs = [];
          for (var i=0; i < $scope.langs.length; i++) {
            langs.push($scope.langs[i].lang);
          }

          var params = {
            name: $scope.profileData.operator.title,
            description: $scope.profileData.operator.description,
            logo_url: $scope.profileData.operatorv2.logo_url,
            localization_languages: langs
          };

          OperatorResource.update(params).$promise
            .then(function (result) {
              ManagerResource.update({id: $scope.manager.id}, {ui_timezone: $scope.selectedTimezone.title}).$promise
                .then(function () {
                  $scope.profileData.loading = false;
                  $rootScope.hideLinearProgress('#profileLoader');
                  ToastService.Small({
                    title: 'Profile successfully updated',
                    color: 'green',
                    icon: 'account-check'
                  });
                })
                .catch(function (reason) {
                  $scope.profileData.loading = false;
                  $rootScope.hideLinearProgress('#profileLoader');
                  $rootScope.debugInfo(reason, 'silent');
                  ToastService.Small({
                    title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                    color: 'amber',
                    icon: 'server-off',
                    blocked: true
                  }, 1000 * 3);
                });
            })
            .catch(function (reason) {
              $scope.profileData.loading = false;
              $rootScope.hideLinearProgress('#profileLoader');
              $rootScope.debugInfo(reason, 'silent');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
            })
        };

        $scope.removeLogo = function() {
          $scope.profileData.operatorv2.logo_url = '';
        };

        $scope.addLang = function() {
          if ($scope.profileData.loading) return;

          $scope.newLangValidateErrors = {};
          $scope.newLang = {};
          $scope.languages = [];

          var existing = {};
          for (var i=0; i < $scope.langs.length; i++) {
            existing[$scope.langs[i].lang] = true;
          }
          for (var i=0; i < languages.length; i++) {
            var lang = languages[i];
            if (existing.hasOwnProperty(lang.id)) {
              continue
            }
            $scope.languages.push(lang);
          }

          var inner = $templateCache.get('add-localization-lang.html');
          inner = $compile(inner)($scope);

          ModalWindowService.Open({
            content: inner,
            keyboard: true,
            actions: [
              {
                title: 'Create',
                color: 'green',
                check: function () {
                  var valid = true;
                  $scope.newRuleValidateErrors = {};
                  if (!_.trim($scope.newLang.title)) {
                    $scope.newLangValidateErrors.lang = true;
                    valid = false;
                  }
                  return valid;
                },
                fn: function () {
                  $scope.langs.push({
                    lang: $scope.newLang.id,
                    title: $scope.newLang.title
                  });
                }
              },
              {
                title: 'Cancel',
                color: 'red',
                fn: function () {
                }
              }
            ]
          });
        };

        //$scope.saveData = function () {
        //  if (this.loading) return;
        //  this.loading = true;
        //  $rootScope.showLinearProgress('#profileLoader');
        //
        //  ProfileService.UpdateOperatorsData($scope.profileData.operator)
        //    .then(function () {
        //      $scope.profileData.loading = false;
        //      $rootScope.hideLinearProgress('#profileLoader');
        //      ToastService.Small({
        //        title: 'Profile successfully updated',
        //        color: 'green',
        //        icon: 'account-check'
        //      });
        //    })
        //    .catch(function (reason) {
        //      $scope.profileData.loading = false;
        //      $rootScope.hideLinearProgress('#profileLoader');
        //      $rootScope.debugInfo(reason);
        //    });
        //};

        $scope.profileData.loading = true;
        $rootScope.showLinearProgress('#profileLoader');

        OperatorRsc.query(function (data) {
/*          $scope.apps = _.get(data, 'operator.platforms', []).map(function (platform) {
            platform.icon = getPlatformIcon(platform);
            platform.app = getPlatformApp(platform);
            platform.title = getPlatformName(platform);
            platform.app_url = getAppUrl(platform);
            return platform;
          });*/

          Platforms.get().$promise
              .then(function (platforms) {
                $scope.apps = platforms.map(function (platform) {
                  platform.icon = getPlatformIcon(platform);
                  platform.title = getPlatformName(platform);
                  platform.app_url = getAppUrl(platform);
                  platform.app_name = platform.app_name || '';
                  platform.app_bundle = platform.app_bundle || '';
                  platform.app_store_url = platform.app_store_url || '';
                  platform.clientID = 'cloud:' + data.operator.extid + '_' + platform.type + '_device';
                  return platform;
                });

                for (var i = 0; i < $scope.apps.length; i += 1) {
                  if ($scope.apps[i].type === 'ottweb') {
                    var service = _.find($rootScope._self.services, {name: 'app.stockweb'});
                    if (service.instance.configuration.aliases && service.instance.configuration.aliases.length) {
                      $scope.apps[i].app_url = 'https://' + service.instance.configuration.aliases[0]
                    }
                    break
                  }
                }
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason);
              });

          $scope.profileData.operator = data.operator;
          OperatorRsc.getCurrentOperator().$promise
              .then(function (response) {
                $scope.profileData.loading = false;
                $rootScope.hideLinearProgress('#profileLoader');
                $scope.profileData.operatorv2 = response.data;
                if ($scope.profileData.operatorv2.localization_languages && $scope.profileData.operatorv2.localization_languages.length) {
                  for (var i = 0; i < $scope.profileData.operatorv2.localization_languages.length; i += 1) {
                    var lang = $scope.profileData.operatorv2.localization_languages[i];
                    $scope.langs.push({
                      lang: lang,
                      title: langCodeToTitle[lang]
                    });
                  }
                }
              })
              .catch(function (reason) {
                $scope.profileData.loading = false;
                $rootScope.hideLinearProgress('#profileLoader');
                $rootScope.debugInfo(reason);
              });
        }, function (reason) {
          $scope.profileData.loading = false;
          $rootScope.hideLinearProgress('#profileLoader');
          $rootScope.debugInfo(reason);
        });

        $scope.editPlatform = function(platform) {
          if ($scope.loading) return;

          $scope.editedPlatform = angular.copy(platform);

          var inner = $templateCache.get('edit-platform.tpl.html');
          inner = $compile(inner)($scope);

          $scope.window = ModalWindowService.Open({
            content: inner,
            isFixed: true,
            clear: true,
            keyboard: true,
            actions: [
              {
                title: 'Update',
                color: 'green',
                fn: function () {
                  $scope.loading = true;

                  const params = {
                    app_name: $scope.editedPlatform.app_name,
                    app_bundle: $scope.editedPlatform.app_bundle,
                    app_store_url: $scope.editedPlatform.app_store_url,
                  }

                  Platforms.update({id: $scope.editedPlatform.id}, params).$promise
                      .then(function () {
                        $scope.loading = false;

                        platform.app_name = $scope.editedPlatform.app_name
                        platform.app_bundle = $scope.editedPlatform.app_bundle
                        platform.app_store_url = $scope.editedPlatform.app_store_url

                        ToastService.Small({
                          title: 'Platform successfully updated',
                          color: 'green',
                          icon: 'account-check'
                        });
                      })
                      .catch(function (reason) {
                        $scope.loading = false;
                        $rootScope.debugInfo(reason, 'silent');
                        ToastService.Small({
                          title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                          color: 'amber',
                          icon: 'server-off',
                          blocked: true
                        }, 1000 * 3);
                      });
                }
              },
              {
                title: 'Cancel',
                color: 'red',
                fn: function () {
                }
              }
            ],
            size: {
              s: 11,
              l: 6
            }
          });
        };

        //ProfileService.GetOperatorData()
        //  .then(function (data) {
        //    $scope.profileData.loading = false;
        //    $rootScope.hideLinearProgress('#profileLoader');
        //    $scope.profileData.operator.title = data.operator.title;
        //
        //    $scope.profileData.operator.description  = data.operator.description;
        //
        //    $scope.apps = data.operator.platforms.map(function (platform) {
        //      platform.icon = getPlatformIcon(platform);
        //      platform.app = getPlatformApp(platform);
        //      platform.title = getPlatformName(platform);
        //      return platform;
        //    });
        //  }, function (reason) {
        //    $scope.profileData.loading = false;
        //    $rootScope.hideLinearProgress('#profileLoader');
        //    $rootScope.debugInfo(reason);
        //  });

      }
    ]);
